"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAppEnv = exports.getAppVariables = exports.getAppTyping = exports.getAppSettings = exports.getAppSessionId = exports.getAppScrolled = exports.getAppConversationId = exports.getAppProductContext = exports.getAppProduct = exports.getAppInputValidation = exports.getAppDebug = exports.getAppContext = exports.getAppBotProjectId = void 0;

var _constants = require("../../constants");

var getAppBotProjectId = function getAppBotProjectId(state) {
  return state.app.botProjectId;
};

exports.getAppBotProjectId = getAppBotProjectId;

var getAppContext = function getAppContext(state) {
  return state.app.context;
};

exports.getAppContext = getAppContext;

var getAppDebug = function getAppDebug(state) {
  return state.app.debug;
};

exports.getAppDebug = getAppDebug;

var getAppInputValidation = function getAppInputValidation(state) {
  return state.app.inputValidation;
};

exports.getAppInputValidation = getAppInputValidation;

var getAppProduct = function getAppProduct(state) {
  return state.app.product;
};

exports.getAppProduct = getAppProduct;

var getAppProductContext = function getAppProductContext(state, env) {
  var product = getAppProduct(state);
  var formattedProductContext = "***** The following is where the customer started their conversation *****\nURL:\nhttps://www.".concat(env === _constants.ENV_STRINGS.prod ? '' : "".concat(env, "-"), "godaddy.com/help/").concat(product, "\nProduct: ").concat(product, "\n***** Following are live messages from the customer *****");
  return formattedProductContext;
};

exports.getAppProductContext = getAppProductContext;

var getAppConversationId = function getAppConversationId(state) {
  return state.app.conversationId;
};

exports.getAppConversationId = getAppConversationId;

var getAppScrolled = function getAppScrolled(state) {
  return state.app.scrolled;
};

exports.getAppScrolled = getAppScrolled;

var getAppSessionId = function getAppSessionId(state) {
  return state.app.sessionId;
};

exports.getAppSessionId = getAppSessionId;

var getAppSettings = function getAppSettings(state) {
  return state.app.settings;
};

exports.getAppSettings = getAppSettings;

var getAppTyping = function getAppTyping(state) {
  return state.app.typing;
};

exports.getAppTyping = getAppTyping;

var getAppVariables = function getAppVariables(state) {
  return state.app.variables;
};

exports.getAppVariables = getAppVariables;

var getAppEnv = function getAppEnv(state) {
  return state.app.env;
};

exports.getAppEnv = getAppEnv;